






import Vue from 'vue';
import RaidOverviewComp from "../components/raid/RaidOverviewComp.vue";

export default Vue.extend({
	name: "MeineRaidsPage",
	components: { RaidOverviewComp },
})
